export default "__VITE_ASSET__c6cc27f5__"